<template>
  <div class="container-inner pt-30 pb-50">
    <b-loading :active.sync="isLoading" :can-cancel="false" />
    <h5 class="c-text_title">マイページ</h5>
    <message-area />
    <div class="tile is-ancestor">
      <div class="tile is-3 is-sidebar is-vertical is-parent">
        <div class="tile is-child"><SidebarMyPage /></div>
      </div>
      <div class="tile is-parent">
        <div class="tile is-child content-padding">
          <h6 class="c-text_title">注文履歴</h6>
          <div class="hr c-4"></div>
          <div class="part-info">
            <table>
              <tr>
                <td class="text-bold">注文番号</td>
                <td>{{ order.orderId }}</td>
              </tr>
              <tr>
                <td class="text-bold">注文日</td>
                <td>{{ formatEnDate(order.createdAt) }}</td>
              </tr>
              <tr>
                <td class="text-bold">発送状況</td>
                <td>{{ shipStatus(order.shippingTime, order.status) }}</td>
              </tr>
              <tr>
                <td class="text-bold">TX ID</td>
                <td>
                  <a :href="`${txHashUrl}${order.txHash}`" target="_blank">{{ order.txHash }}</a>
                </td>
              </tr>
            </table>
          </div>
          <div class="part-info">
            <table>
              <tr>
                <td class="text-bold">お届け先</td>
                <td v-if="order.shipAddress">
                  <span>{{ order.shipAddress.receiverName }}</span> <br />
                  <span>〒{{ order.shipAddress.zipcode }}</span> <br />
                  <span>{{ order.shipAddress.address }}</span> <br />
                  <span>{{ order.shipAddress.phoneNumber }}</span>
                </td>
              </tr>
            </table>
          </div>
          <div class="part-info">
            <table v-if="order.product">
              <tr>
                <td class="text-bold">商品情報</td>
                <td class="img-row">
                  <img
                    :src="
                      order.product && order.product.image
                        ? order.product.image[0] ||
                          require('@/assets/images/goods_default.svg')
                        : require('@/assets/images/goods_default.svg')
                    "
                  />
                </td>
                <td class="product-detail-row">
                  <table>
                    <tr>
                      <td>商品名</td>
                      <td><span v-line-clamp="2">{{ order.product.name }}</span></td>
                    </tr>
                    <tr>
                      <td>単価</td>
                      <td>
                        : {{ formatPrice(unitPrice) }} {{ $t('common.currency') }}
                      </td>
                    </tr>
                    <tr>
                      <td>注文個数</td>
                      <td>: {{ order.quantity }}</td>
                    </tr>
                    <tr>
                      <td>支払い金額</td>
                      <td>
                        : {{ formatPrice(order.totalPrice) }}
                        {{ $t('common.currency') }}
                      </td>
                    </tr>
                  </table>

                  <button
                    v-if="order.status == 1 && isOwner()"
                    class="button"
                    @click="confirmShow"
                  >
                    注文を決済する
                  </button>
                  <button
                    v-if="order.status == 3"
                    class="button"
                    @click="receivedShow"
                  >
                    商品受取確認
                  </button>
                  <button
                    v-if="order.status == 4"
                    class="button"
                    @click="toReviews"
                  >商品へのレビュー</button>
                </td>
              </tr>
            </table>
          </div>
          <div class="part-info">
            <table>
              <tr>
                <td class="text-bold">販売者</td>
                <td v-if="order.product">
                  <router-link
                    :to="'/customer/shop/' + order.product.owner"
                    class="shop-name"
                  >
                    <span v-line-clamp="1">{{ order.product.shopName }}</span> <br />
                  </router-link>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <b-modal :active.sync="isReceivedShowActive" has-modal-card>
        <ConfirmPopup
          :item="{
            route: productRoute,
            title: productName,
            subtitle: shopName,
            image: productImage,
            date: shippingTime
          }"
          :confirm="confirm"
          :action-one="() => confirmReceive()"
          :action-two="() => toReviews()"
          title="商品が到着しましたか？"
        />
    </b-modal>
  </div>
</template>
<style lang="scss" src="./order-detail.scss" scoped>
</style>

<script>
import SidebarMyPage from '@/components/sidebar/sidebar-mypage/sidebar-mypage';
import MessageArea from '@/components/common/message-area/message-area.vue';
import ConfirmPopup from '@/components/common/confirm-popup/confirm-popup.vue';
import messageUtils from '../../../../utils/mixins/messageUtils';
import dataTransform from '../../../../utils/mixins/dataTransform';
import { getOrderDetail } from '../../../../services/order.service';
import { getProductDetail } from '../../../../services/product.service';
import { isMetaMaskEnabled, isMainNetwork, paymentConfirms, finishPayment } from '../../../../services/payment.service';
import { changeReadStatusNotificationByOrder } from '../../../../services/notification.service';
import { NOTIFY_CATEGORY, NOTIFY_TYPE, NOTIFY_CONTENT_TYPE } from '../../../../services/constants';
import { getNotificationFromOrder } from '../../../../utils/commonUtil';
import { getPublicKey } from '../../../../services/user.service';
import { getShopInfo } from '../../../../services/shop.service';

export default {
  name: 'CustomerOrderDetail',
  components: {
    ConfirmPopup,
    SidebarMyPage,
    'message-area': MessageArea
  },
  mixins: [messageUtils, dataTransform],
  data() {
    return {
      orderId: null,
      order: {},
      ownerOrderAddr: '',
      shop: null,
      confirm: false,
      isReceivedShowActive: false
    };
  },
  computed: {
    unitPrice: function() {
      let result = 0;
      if (this.order) {
        result = (this.order.totalPrice - this.order.shippingFee) / this.order.quantity;
      }
      return result;
    },
    canConfirm: function() {
      return this.order ? this.order.status === 1 || this.order.status === 2 : false;
    },
    productRoute: function() {
      return this.order && this.order.product ? { path: `/customer/product/detail/${this.order.product.id}` } : null;
    },
    productName: function() {
      return this.order && this.order.product && this.order.product.name ? this.order.product.name : '';
    },
    productImage: function() {
      return this.order && this.order.product && this.order.product.image && this.order.product.image.length
        ? this.order.product.image[0]
        : require('@/assets/images/goods_default.svg');
    },
    shippingTime: function() {
      let dateLabel = '';
      if (this.order && this.order.shippingTime) {
        const date = this.$moment(this.order.shippingTime * 1000);
        dateLabel = `${date.format('YYYY/M/D')}`;
      }
      return dateLabel;
    },
    shopName: function() {
      return this.order && this.order.shop && this.order.shop.name ? this.order.shop.name : '';
    },
    txHashUrl: function() {
      return this.$txHashUrl;
    }
  },
  created() {
    this.orderId = parseInt(this.$route.params.orderId, 10);
    this.getDetail();
    getPublicKey().then(res => {
      this.ownerOrderAddr = res;
    });
  },
  methods: {
    async getDetail() {
      const that = this;
      this.loading++;
      const { status, result } = await getOrderDetail(this.orderId, (nextStatus, txHash) => {
        that.order.txHash = txHash;
        that.order.status = nextStatus;
        let messageId = 'EF2068_Content';
        if (nextStatus === 4) {
          messageId = 'EF2071_Content';
        }
        that.updateMessage(1, { messageId });
      });

      if (!status) {
        this.loading--;
        this.updateMessage(status, result);
        return;
      }

      const order = result.data;
      order.shipAddress = JSON.parse(order.shippingAddress);
      const res = await Promise.all([getProductDetail(Number(order.productId)), getShopInfo(order.shopAddr)]);

      if (!res[0].status) {
        this.loading--;
        this.updateMessage(0, { messageId: 'EF2146_Content' });
        return;
      }

      if (!res[1].status) {
        this.loading--;
        this.updateMessage(0, { messageId: 'EF2146_Content' });
        return;
      }

      this.order = { ...order, product: res[0].result.data, shop: res[1].result.data };
      this.loading--;
    },
    isOwner() {
      if (!this.ownerOrderAddr || !this.order.cusAddr) return false;
      return this.ownerOrderAddr.toLowerCase() === this.order.cusAddr.toLowerCase();
    },
    confirmShow() {
      this.$dialog.confirm({
        title: '決済確認',
        message: this.$t('EF2066_Content'),
        cancelText: 'キャンセル',
        confirmText: 'OK',
        type: 'is-primary',
        onConfirm: () => this.confirmPayment()
      });
    },
    receivedShow() {
      this.isReceivedShowActive = true;
    },
    toReviews() {
      if (!this.confirm && this.isReceivedShowActive) return;

      this.$root.$router.push({
        name: 'ReviewForProduct',
        params: {
          productId: this.order.productId,
          orderId: this.orderId,
          orderStatus: parseInt(this.order.status, 10)
        }
      });
    },
    async confirmPayment() {
      if (!(await isMetaMaskEnabled())) {
        // eslint-disable-next-line no-alert
        alert('MetaMask is not enabled !');
        return;
      }
      if (!(await isMainNetwork())) {
        // eslint-disable-next-line no-alert
        alert('Is not MainNetwork !');
        return;
      }

      try {
        this.clearMessage();
        this.loading++;
        const paymentRes = await paymentConfirms([this.order]);
        const data = paymentRes.result.data[0];
        if (!data || !data.txHash) {
          this.updateMessage(0, { messageId: 'EF2067_Content' });
        } else {
          this.updateMessage(1, { messageId: 'EF2068_Content' });
        }
        this.loading--;
      } catch (error) {
        this.loading--;
        return;
      }
    },
    async confirmReceive() {
      try {
        this.clearMessage();
        this.loading++;
        if (this.confirm) {
          this.loading--;
          return;
        }

        const confirmRes = await finishPayment(this.order);
        const data = confirmRes.result.data;
        if (!data || data.status !== 4) {
          this.updateMessage(0, { messageId: 'EF2069_Content' });
        } else {
          this.updateMessage(1, { messageId: 'EF2071_Content' });
          this.confirm = true;
          this.order = data;
          await changeReadStatusNotificationByOrder(this.order.orderId, NOTIFY_CONTENT_TYPE.SHIPPED);
        }
        this.loading--;
      } catch (error) {
        this.loading--;
        return;
      }
    },
    shipStatus(string, status) {
      let orderDate = '';
      let orderStatus = '';
      if (status === 1 || status === 2) {
        orderStatus = '未発送';
      } else if (status === 3 || status === 4) {
        orderDate = this.formatEnDate(string);
        orderStatus = '発送済';
      }
      return `${orderStatus} ${orderDate}`;
    }
  }
};
</script>

<style>
</style>
